<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';

const DEFAULT_VALUE = 'no-repeat';

export default {
    name: 'background-image-repeat',
    mixins: [baseOption],

    data() {
        return {
            customAttributeProp: 'background-repeat',
            displayName: 'Repeat',
            tailwindDefinitionProp: 'backgroundRepeat',
            message: '',
            value: DEFAULT_VALUE,
        };
    },

    computed: {
        options() {
            return this.themeObjectKeys.map((k) => {
                return {
                    text: this.titleCase(k),
                    value: k,
                };
            });
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(valueNew) {
            if (valueNew === DEFAULT_VALUE) {
                this.onRemove();
            } else {
                this.onAdd(valueNew);
                this.onOptionChange();
            }
            this.value = valueNew;
        },

        onAdd(valueNew) {
            switch (this.screen) {
                case 'mob':
                    this.addFlexClass({ key: valueNew, screen: 'mob' });
                    break;

                case 'tab':
                    this.addFlexClass({ key: valueNew, screen: 'tab' });
                    break;

                case 'lap':
                    this.addFlexClass({ key: valueNew, screen: 'lap' });
                    break;

                default:
                    this.addFlexClass({ key: valueNew, screen: 'mob' });
                    this.addFlexClass({ key: valueNew, screen: 'tab' });
                    this.addFlexClass({ key: valueNew, screen: 'lap' });
                    this.addFlexClass({ key: valueNew, screen: 'des' });
            }
        },

        onRemove() {
            switch (this.screen) {
                case 'mob':
                    this.removeFlexClass('default', 'mob');
                    break;

                case 'tab':
                    this.removeFlexClass('default', 'tab');
                    break;

                case 'lap':
                    this.removeFlexClass('default', 'lap');
                    break;

                default:
                    this.removeFlexClass('default', 'mob');
                    this.removeFlexClass('default', 'tab');
                    this.removeFlexClass('default', 'lap');
                    this.removeFlexClass('default', 'des');
            }
        },

        onSelectedElement() {
            this.value = this.flexClassDefinition.key || DEFAULT_VALUE;
        },

        onConflict() {
            this.removeFlexClass();
            this.value = DEFAULT_VALUE;
        },
    },
};
</script>
